const services = [
  {
    id: 'striping',
    title: 'Parking Lot Striping',
    image: 'https://public.readdy.ai/ai/img_res/8c2678f7150659fd30727f725db32046.jpg',
    description: 'Professional line striping services to keep your parking lot organized, safe, and compliant with ADA regulations.',
    benefits: [
      'ADA-compliant handicap spaces and signage',
      'Fire lane and no parking zone markings',
      'Directional arrows and traffic flow indicators',
      'Custom stenciling for reserved spaces',
      'High-visibility paint for long-lasting results',
      'Fast turnaround to minimize disruption'
    ]
  },
  {
    id: 'sealcoating',
    title: 'Asphalt Sealcoating',
    image: 'https://readdy.ai/api/search-image?query=commercial%20asphalt%20sealcoating%20application%20in%20progress%2C%20professional%20crew%20applying%20black%20sealant%20to%20parking%20lot%20surface%2C%20industrial%20sealcoat%20sprayer%20equipment%2C%20fresh%20wet%20black%20coating%20on%20asphalt%2C%20commercial%20property%20maintenance%20work%2C%20professional%20pavement%20protection%20service&width=800&height=500&seq=service-seal-001&orientation=landscape',
    description: 'Protect your asphalt investment with premium sealcoating that extends pavement life and enhances curb appeal.',
    benefits: [
      'Extends asphalt lifespan by 3-5 years',
      'Protects against UV rays, water, and chemicals',
      'Restores rich black appearance',
      'Prevents oxidation and cracking',
      'Cost-effective preventative maintenance',
      'Commercial-grade materials for durability'
    ]
  },
  {
    id: 'crack-sealing',
    title: 'Crack Sealing',
    image: 'https://readdy.ai/api/search-image?query=professional%20asphalt%20crack%20sealing%20work%20close%20up%2C%20hot%20rubberized%20crack%20filler%20being%20applied%20to%20pavement%20cracks%2C%20commercial%20crack%20sealing%20equipment%20and%20materials%2C%20detailed%20view%20of%20quality%20repair%20work%2C%20black%20asphalt%20surface%20maintenance%2C%20professional%20pavement%20preservation&width=800&height=500&seq=service-crack-001&orientation=landscape',
    description: 'Prevent water infiltration and further damage with professional crack sealing using hot-applied rubberized materials.',
    benefits: [
      'Prevents water from penetrating base layers',
      'Stops crack expansion and deterioration',
      'Hot-applied rubberized sealant',
      'Flexible material moves with pavement',
      'Cost-effective preventative measure',
      'Extends time between major repairs'
    ]
  },
  {
    id: 'pothole-repair',
    title: 'Pothole and Asphalt Repair',
    image: 'https://readdy.ai/api/search-image?query=commercial%20pothole%20repair%20and%20asphalt%20patching%20work%2C%20professional%20crew%20filling%20damaged%20pavement%20area%20with%20hot%20asphalt%2C%20industrial%20paving%20equipment%20and%20tools%2C%20parking%20lot%20repair%20in%20progress%2C%20quality%20asphalt%20restoration%20work%2C%20commercial%20property%20maintenance&width=800&height=500&seq=service-repair-001&orientation=landscape',
    description: 'Fast, reliable pothole repair and asphalt patching to restore safety and appearance to your parking lot.',
    benefits: [
      'Eliminates trip hazards and liability risks',
      'Hot-mix asphalt for permanent repairs',
      'Proper compaction for long-lasting results',
      'Same-day service available',
      'Prevents further pavement deterioration',
      'Improves overall lot appearance'
    ]
  },
  {
    id: 'ada-compliance',
    title: 'ADA and Fire Lane Compliance',
    image: 'https://readdy.ai/api/search-image?query=ADA%20compliant%20handicap%20parking%20space%20with%20blue%20painted%20markings%20and%20wheelchair%20symbol%2C%20professional%20accessibility%20striping%20and%20signage%2C%20fire%20lane%20red%20curb%20painting%2C%20commercial%20parking%20lot%20compliance%20markings%2C%20clear%20daylight%20photography%2C%20regulatory%20pavement%20markings&width=800&height=500&seq=service-ada-001&orientation=landscape',
    description: 'Ensure your property meets all ADA accessibility requirements and fire safety regulations with proper markings and signage.',
    benefits: [
      'Full ADA compliance assessment',
      'Proper handicap space dimensions',
      'Access aisle and van-accessible markings',
      'Fire lane red curb painting',
      'Regulatory signage installation',
      'Avoid fines and liability issues'
    ]
  },
  {
    id: 'maintenance-plans',
    title: 'Parking Lot Maintenance Plans',
    image: 'https://readdy.ai/api/search-image?query=well%20maintained%20commercial%20parking%20lot%20with%20fresh%20striping%20and%20sealed%20asphalt%2C%20pristine%20retail%20center%20parking%20area%2C%20professional%20pavement%20maintenance%20results%2C%20clean%20organized%20parking%20spaces%2C%20aerial%20view%20of%20quality%20lot%20upkeep%2C%20commercial%20property%20excellence&width=800&height=500&seq=service-maint-001&orientation=landscape',
    description: 'Scheduled maintenance programs to keep your parking lot in top condition year-round with predictable budgeting.',
    benefits: [
      'Customized maintenance schedules',
      'Priority service and scheduling',
      'Predictable annual budgeting',
      'Regular inspections and assessments',
      'Preventative care extends pavement life',
      'Dedicated account management'
    ]
  }
];

export default function ServicesList() {
  return (
    <section className="py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-24">
          {services.map((service, index) => (
            <div
              key={service.id}
              id={service.id}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-80 object-cover object-top"
                  />
                </div>
              </div>

              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Oswald, sans-serif' }}>
                  {service.title}
                </h2>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  {service.description}
                </p>
                <ul className="space-y-3 mb-8">
                  {service.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-yellow-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                      <span className="text-gray-700">{benefit}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#quote"
                  className="inline-flex items-center px-6 py-3 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-all whitespace-nowrap cursor-pointer"
                >
                  Get Quote for This Service
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
